export const __DEV__ = process.env.NODE_ENV !== 'production'

export const API_HOST =
  process.env.NEXT_PUBLIC_API_HOST || 'http://localhost:27312'
export const SELF_HOST = process.env.NODE_ENV === 'production' ? 'https://shelltime.xyz' : 'http://localhost:3302'

export const FE_HOST = 'https://shelltime.xyz'

export const STORAGE_TOKEN_KEY = 'mt:token'
export const STORAGE_UID_KEY = 'mt:uid'
export const STORAGE_REFRESH_TOKEN_KEY = 'mt:refreshToken'
export const STORAGE_LANG_KEY = 'mt-lang'

export const SUPPORTING_EMAIL = 'annatar.he+shelltime.xyz@gmail.com'
export const RESEND_API_KEY = process.env.RESEND_API_KEY
export const REDIS_URL = process.env.REDIS_URL
export const MAIL_SECURITY_KEY = process.env.MAIL_SECURITY_KEY
export const RESEND_EMAIL_FROM =
  'ShellTime <clippingkk@no-reply-clippingkk.annatarhe.com>'

export const STRIPE_CUSTOMER_PORTAL =
  'https://billing.stripe.com/p/login/00gcOiaM43is96E9AA' as const

export const INSTALL_SCRIPT =
  'curl -sSL https://raw.githubusercontent.com/shelltime/installation/master/install.bash | bash' as const

export const STRIPE_PLANS = {
  pioneer: {
    monthly: {
      lookupKey: 'pioneer_monthly',
      price: 12,
      currency: 'usd',
      interval: 'month',
    },
    yearly: {
      lookupKey: 'pioneer_yearly',
      price: 120,
      currency: 'usd',
      interval: 'year',
    },
  },
} as const

export type StripePlans = typeof STRIPE_PLANS

type LookupKeys<T> = T extends { lookupKey: infer K }
  ? K
  : { [K in keyof T]: LookupKeys<T[K]> }[keyof T]

export type StripePlanLookupKeys = LookupKeys<typeof STRIPE_PLANS>
